import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import NetworkTiles from "@/components/dashboard/NetworkTiles";
import BuyAirtimeForm from "@/components/forms/BuyAirtimeForm";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { GetRequest, PostRequest } from "@/lib/http";
import { toast } from "sonner";
import { useForm } from "react-hook-form";
import Unavailable from "@/components/Unavailable";
import { useSelector } from "react-redux";
import AirtimeSkeleton from "@/components/skeletons/airtime-skeleton";
import AnnouncementMessage from "@/components/dashboard/AnnouncementMessage";

const BuyAirtime = () => {
  const [networkType, setNetworkType] = useState("");
  const [loading, setLoading] = useState(true);
  const [telcos, setTelcos] = useState([]);
  const [insertedPhoneNumber, setInsertedPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openAirtimeDrawer, setOpenAirtimeDrawer] = useState(false);

  const user = useSelector((state) => state.user.user);

  const location = useLocation();
  const beneficiaryData = location.state;

  if (!user.meta_data?.airtime_active) return <Unavailable />;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    reset,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      amount: 0,
      beneficiary: false,
    },
  });

  async function getData() {
    const { data, err } = await GetRequest({
      url: "/api/airtime-details",
      setState: setLoading,
    });

    if (!err) {
      setTelcos(data.networks);
      if (beneficiaryData) {
        setValue("phone", beneficiaryData.value);

        const telcoIndex = data.networks.findIndex((t) =>
          beneficiaryData.network
            ?.toLowerCase()
            ?.includes(t && t.toLowerCase()),
        );

        setValue("carrier", telcoIndex);
      }
    } else {
      toast.error(err);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const network = watch("carrier");

  const onSubmit = async (body) => {
    setIsSubmitting(true);

    const { carrier, ...restBody } = body;
    const stringCarrier = carrier && telcos[carrier]?.toString();

    const { err } = await PostRequest({
      url: "/api/buyAirtime",
      body: { ...restBody, carrier: stringCarrier },
      errorMessage: "Sorry, An error occurred while purchasing data",
    });
    if (!err) {
      toast.success("Airtime purchased successfully");
      reset();
      setOpenAirtimeDrawer(false);
    } else {
      toast.error("Airtime purchase failed", {
        description: err,
      });
      setOpenAirtimeDrawer(false);
    }
    setIsSubmitting(false);
  };

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Buy Airtime Online"
        description="Quickly purchase airtime for your mobile phone with our easy-to-use platform. Stay connected with instant top-ups and secure transactions!"
      />

      {/* {network && telcos[network] === "Airtel" && (
        <div className="mx-2">
          <AnnouncementMessage msg="AIRTEL USERS: Please ensure you have no outstanding balance before making a data purchase." />
        </div>
      )} */}

      <section className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Instant Airtime Purchase"
            subtext="Get your mobile balance topped up instantly—stay online and in touch!"
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Buy Airtime</span>
            </h2>
          </div>
        </div>

        {/* change to !loading */}
        {!loading ? (
          <>
            <NetworkTiles
              networkType={networkType}
              setNetworkType={setNetworkType}
              watch={watch}
              setValue={setValue}
              valueKey="carrier"
              telcos={telcos}
              selected={telcos?.[watch("carrier")]}
            />
            {network && telcos[network] === "Airtel" ? (
              <div className="mx-2 mt-2">
                <AnnouncementMessage msg="AIRTEL USERS: Please ensure you have no outstanding balance before making a data purchase." />
              </div>
            ) : (
              <marquee direction="left" className="font-bold">
                All mobile network services - [Airtime Recharge] - *311# -
                [AccountBalance] - *310# - [Share Services] - *321# - [Borrowing
                Services] -[Data Plans] - *312# - *303# - [Data Balance] - *321#
              </marquee>
            )}
            <BuyAirtimeForm
              telcos={telcos}
              networkType={networkType}
              setNetworkType={setNetworkType}
              register={register}
              handleSubmit={handleSubmit}
              control={control}
              errors={errors}
              onSubmit={onSubmit}
              setValue={setValue}
              watch={watch}
              setError={setError}
              clearErrors={clearErrors}
              insertedPhoneNumber={insertedPhoneNumber}
              setInsertedPhoneNumber={setInsertedPhoneNumber}
              loading={isSubmitting}
              setLoading={setIsSubmitting}
              beneficiaryData={beneficiaryData}
              openAirtimeDrawer={openAirtimeDrawer}
              setOpenAirtimeDrawer={setOpenAirtimeDrawer}
            />{" "}
          </>
        ) : (
          <AirtimeSkeleton />
        )}
      </section>
    </AnimatedPage>
  );
};

export default BuyAirtime;
